import { SYNC_STATUS } from '../../redux/sync/constants'

export const SYNC_BUSY_TOOLTIP = 'Aguarde a sincronização terminar.'

/**
 * Sync parado: o último ciclo terminou, com sucesso (2) ou com erro (0). QA HML F7: exigir só o
 * 2 bloqueava Sair/Limpar/Atualizar para sempre com um registro recusado (reenviado e recusado a
 * cada ciclo => currentSync=0). Quem protege os dados é o gate (pendingGate), não este botão.
 */
export function isSyncIdle(currentSync: unknown): boolean {
  return (
    currentSync === SYNC_STATUS.SUCCESS || currentSync === SYNC_STATUS.ERROR
  )
}

/** Sair e "Atualizar versão" da barra lateral: online + sync parado (mesma regra do Limpar). */
export function getSidebarSyncActionState(i: {
  currentSync: unknown
  online: boolean
}) {
  if (!i.online) return { disabled: true, tooltip: 'Sem internet.' }
  if (!isSyncIdle(i.currentSync))
    return { disabled: true, tooltip: SYNC_BUSY_TOOLTIP }
  return { disabled: false, tooltip: undefined }
}

/** A1–A3: habilitado só online + sync parado (mesma regra do Sair e do "Atualizar versão"). */
export function getCleanupButtonState(i: {
  currentSync: unknown
  online: boolean
}) {
  if (!i.online)
    return {
      disabled: true,
      tooltip:
        'Sem internet. Conecte-se para limpar e baixar os dados de novo.',
    }
  if (!isSyncIdle(i.currentSync))
    return { disabled: true, tooltip: SYNC_BUSY_TOOLTIP }
  return {
    disabled: false,
    tooltip:
      'Apaga os dados deste aparelho e baixa de novo. Você continua logado.',
  }
}
